import { createContext, useContext } from 'react';
import { useImmerReducer } from 'use-immer';

const accountInit = {
    accounts: {},
    filteredAccounts: [],
    updateAccount: {},
    trashAccountId: null,
    restoreAccountId: null,
    isLoadingAccounts: false,
    // error: {existingUsers: [{...}, {...}]}
    accountErrors: {existingUsers: false}
};

function accountsReducer ( draft, { type, payload } ) {
    switch (type) {
        // GET accounts
        case 'setAccounts': {
            const newState = {}
            for (let i = 0; i < payload.Accounts.length; i++) {
                let account = payload.Accounts[i]
                newState[[account.id]] = account
            }
            draft.accounts = newState
            break;
        }
        case "createAccountError": {
          let newState = {"existingUsers": {}}
          if (payload.existingUsers) {
            for (let i = 0; i < payload.existingUsers.length; i++) {
              let user = payload.existingUsers[i]
              newState.existingUsers[user.id] = user
            }
            draft.accountErrors = newState;
          } else {
            draft.accountErrors = payload
          }
          break;
        }
        case 'setIsLoadingAccounts': {
            draft.isLoadingAccounts = payload;
            break;
        }
        case 'setUpdateAccount': {
            draft.updateAccount = payload
            break;
        }
        case 'setTrashAccountId': {
            draft.trashAccountId = payload
            break;
        }
        case 'setRestoreAccountId': {
            draft.restoreAccountId = payload
            break;
        }
        case 'addAccount': {
            draft.accounts[[payload.id]] = payload
            break;
        }
        case 'editAccount': {
            draft.accounts[[payload.id]] = {...draft.accounts[[payload.id]], ...payload}
            break;
        }
        case 'setFilteredAccounts': {
            draft.filteredAccounts = payload;
            break;
        }
        default: {
            return null;
        }
    }
}

const [AccountContext, AccountDispatchContext] = [createContext(null),createContext(null)];

export default function AccountProvider ({ init, children }) {
    const [accountStore, dispatch] = useImmerReducer(accountsReducer, init||accountInit);

    return (
        <AccountContext.Provider value={accountStore}>
            <AccountDispatchContext.Provider value={dispatch}>
                {children}
            </AccountDispatchContext.Provider>
        </AccountContext.Provider>
    )
}

export function useAccountStore() {
    return useContext(AccountContext);
}

export function useAccountDispatch() {
    return useContext(AccountDispatchContext);
}